/**
 * Whether NPCs may offer a quest (plan 24 D28/D29, lane AQ).
 *
 * A quest authored `offered = false` stays in the database — its id, body and
 * player saves are untouched, and a hero already on it can still finish it —
 * but no NPC lists it, no marker or teaser points at it, and the server
 * refuses to grant it. `unofferedReason` says what has to change before it is
 * switched back on.
 */
export function isQuestOffered(quest: { offered?: boolean } | null | undefined): boolean {
  return !!quest && quest.offered !== false;
}
